var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pc-dialog',{attrs:{"title":"活动规则","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.close,"confirm":_vm.close},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"rule"},[_vm._v(_vm._s(_vm.rule))])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }